interface Props {
  scrollToVideo?: () => void
}

export function GoHeader({ scrollToVideo }: Props) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px 0",
        textAlign: "center",
        gap: 20,
        overflow: "hidden",
      }}
    >
      <div style={{ maxWidth: 900 }}>
        <h1 className="mk-title">
          A new app worthy <span className="mk-title-accent">of a place on your home screen</span>
        </h1>
        <p className="mk-subtitle" style={{ fontWeight: 500 }}>
          Built by real people, for real life. Used by busy people everywhere.
        </p>
      </div>

      <div
        style={{
          display: "flex",
          gap: 20,
          width: "100%",
          maxWidth: 600,
          marginTop: 40,
          justifyContent: "center",
        }}
      >
        <a href="https://totodo.app/" className="mk-cta mk-cta-primary">
          Start for free
        </a>
        <button
          className="mk-cta mk-cta-secondary"
          onClick={scrollToVideo}
        >
          Watch demo
        </button>
      </div>

      <img
        src="/marketing/go/go-hero-app-visual.png"
        alt="ToToDo app interface preview"
        style={{ marginTop: 40, marginBottom: -56, maxWidth: "100%" }}
      />
    </div>
  )
}
